// 1. Extend the global PromiseConstructor so TypeScript recognizes the method
declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
}

// 2. Implement the polyfill with generic typing
if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function <T>() {
    // Use the definite assignment assertion (!) because TypeScript
    // doesn't know the Promise executor runs synchronously
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}

// If this is in a standalone file, you may need this line to
// force TypeScript to treat the file as a module:
export {};
